import * as React from "react"
import { bindActionCreators, Dispatch } from "redux"
import { connect } from "react-redux"
import BasePage, { Props as BaseProps } from "../base-page"
import * as actionCreators from "../../action-creators"
import * as InstructionsService from "../../service/sfp/instructions-service-2"
import { List, ListItem } from "../list"
import * as Toolbar from "../toolbar"
import * as UserDomain from "../../domain/sfp/user-domain"
import { Instruction } from "../../model"
import { ReducerState, MappedActionsProps } from "../../reducer"
import * as routes from "../../util/routes"

class InstructionList extends BasePage<InjectedProps, State> {
	protected editingProfiles: UserDomain.Profile[] = [
		UserDomain.Profile.SuperAdmin
	]
	protected viewingProfiles: UserDomain.Profile[] = [
		UserDomain.Profile.SuperAdmin
	]
	protected toolbar: Toolbar.ToolbarItem[] = this.getToolbarItems()
	private abortController = new AbortController()

	constructor(props: Readonly<InjectedProps>) {
		super(props)
		this.state = { loading: true, instructions: [] }
	}

	componentDidMount() {
		this.props.actions.setPageTitle("Instructions")

		InstructionsService.findInstructions(this.abortController.signal)
		.then(instructions => {
			this.setState({ loading: false, instructions });
		}, error => {
			this.props.actions.throwError(error);
			this.setState({ loading: false });
		})
	}

	componentWillUnmount() {
		this.abortController.abort()
		this.setState({ loading: false })
	}

	renderPageContent() {
		return <List>
			{this.state.instructions && 0 === this.state.instructions.length
			? <ListItem secondaryText="Aucune instruction" />
			: this.state.instructions.map(instruction => (
				<ListItem
				id={`nomeclature-${instruction.id}`}
				key={instruction.id}
				primaryText={instruction.name}
				route={`${routes.INSTRUCTIONS}/${instruction.id}`} />))}
		</List>
	}

	protected isLoading(): boolean {
		return super.isLoading() || this.state.loading
	}

	private getToolbarItems(): Toolbar.ToolbarItem[] {
		return [{
			to: routes.INSTRUCTIONS_ADD,
			icon: "plus",
			text: "Ajouter une instruction",
			title: "Ajouter une instruction"
		}]
	}
}

function mapDispatchToProps(dispatch: Dispatch<ReducerState>): MappedActionsProps {
	return { actions: bindActionCreators(actionCreators, dispatch) }
}

function mapStateToProps(state: ReducerState): ReducerState {
	return state
}

export default connect(mapStateToProps, mapDispatchToProps)(InstructionList)

export interface Props extends BaseProps {}

interface State {
	loading: boolean;
	instructions: Instruction[];
}

type InjectedProps = MappedActionsProps & Props & ReducerState



// WEBPACK FOOTER //
// ./src/component/instructions/instruction-list.tsx